import variables from '../../variables';
import {$data} from '../../helpers/data';
import is from 'is_js';
import {$dom} from '../../helpers/dom';
import Swiper, {Lazy, Pagination, EffectFade, Autoplay} from 'swiper';
Swiper.use([Lazy, Pagination, EffectFade, Autoplay]);

// import {EffectCoverflow, EffectFade, Lazy, Navigation, Swiper, Pagination} from 'swiper';
// Swiper.use([Navigation, EffectFade, Lazy, EffectCoverflow, Pagination]);


const {deepAssign} = $data;

export default class CarouselController {
  constructor() {

    this.defaults = {
      slidesPerView: 1,
      spaceBetween: 30,
      slideActiveClass: variables.classNames.active,
      speed: variables.carouselDefaultDuration,
      navigation: {
        disabledClass: variables.classNames.disabled
      }
    };

    this.carousels = [];

  }

  create(carousels) {
    if(is.array(carousels)) {
      this.carousels = carousels.map(carousel => {
        let opts = {}, swiper;

        const {apiOptions, customOptions} = carousel;

        if (apiOptions && is.object(apiOptions)) {
          opts = deepAssign(
            $data.cloneObject(this.defaults),
            apiOptions
          );
        }

        if (customOptions && is.object(customOptions)) {

          const modifiedCustomOptions = {};

          const {navHolder, lazy} = customOptions;

          if (navHolder && is.string(navHolder)) {
            modifiedCustomOptions['navigation'] = {
              prevEl: $dom.get('.is-control--prev', navHolder),
              nextEl: $dom.get('.is-control--next', navHolder)
            }
          }

          if (lazy && is.boolean(lazy)) {
            modifiedCustomOptions['preloadImages'] = false;
            modifiedCustomOptions['lazy'] = variables.defaultSwiperLazyOptions;
          }

          opts = deepAssign(
            modifiedCustomOptions,
            opts
          );

          swiper = new Swiper(carousel.target, opts)
        }


        return is.undefined(swiper) ? new Swiper(carousel.target, opts) : swiper;
      });
    }

    return this.carousels;
  }

  destroy() {
    return this.carousels.filter(carousel => {
      carousel.destroy();
      return false;
    })
  }
}